import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import warn from '../../utils/warn.js';
import { usePaginationPerPageSelect } from './hooks/usePaginationPerPageSelect.js';
import { setSelectAriaLabelDefault, PER_PAGE_SELECT_BEFORE_LABEL_DEFAULT, setPerPageSelectAfterLabelDefault } from './defaultStrings.js';
import { jsx } from '@emotion/react';
import { Text } from '../Text/Text.js';
import { Select } from '../Select/Select.js';
import './hooks/usePaginationContext.js';
import './PaginationContext.js';
import '../../utils/createResponsive.js';
import '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import '@indeed/ifl-icons/ChevronDown';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../../constants/index.js';
import '../../utils/mergeRefs.js';
import '../../hooks/useHasFocus.js';
import '../IconWrapper/IconWrapper.js';

const PerPageContainer = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: ["orientation"],
  shouldForwardProp: prop => prop !== "orientation",
  target: "e1gdqogr0"
} : {
  styleProps: ["orientation"],
  shouldForwardProp: prop => prop !== "orientation",
  target: "e1gdqogr0",
  label: "PerPageContainer"
})(_ref => {
  let {
    orientation
  } = _ref;
  return {
    alignItems: "center",
    border: "1px solid",
    borderColor: "background",
    borderRadius: "md",
    boxSizing: "border-box",
    bg: "background",
    display: "flex",
    flexGrow: orientation === "vertical" ? 1 : 0,
    justifyContent: "center",
    listStyle: "none",
    marginInlineEnd: 0,
    marginInlineStart: 0,
    marginBlockEnd: 0,
    marginBlockStart: 0,
    paddingInlineEnd: 4,
    paddingInlineStart: 4,
    paddingBlockEnd: 2,
    paddingBlockStart: 2
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const PaginationPerPageSelect = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    itemsPerPageOptions,
    onItemsPerPageChange,
    beforeLabel = PER_PAGE_SELECT_BEFORE_LABEL_DEFAULT,
    setAfterLabel = setPerPageSelectAfterLabelDefault,
    setSelectAriaLabel = setSelectAriaLabelDefault
  } = _ref2;
  const {
    paginationContext,
    handleSelectChange
  } = usePaginationPerPageSelect({
    onItemsPerPageChange
  });
  if (!paginationContext) {
    warn("<PaginationPerPageSelect> should only be used within a parent <Pagination> component.");
    return null;
  }
  const {
    totalItems,
    itemsPerPage,
    orientation
  } = paginationContext;
  return jsx(PerPageContainer, {
    ref: ref,
    orientation: orientation
  }, jsx(Text, {
    variant: "contrast"
  }, beforeLabel), jsx(Select, {
    sx: {
      inlineSize: "10ch",
      marginInlineStart: 2,
      marginInlineEnd: 2,
      "& > select": {
        paddingInlineEnd: 6
      }
    },
    "aria-label": setSelectAriaLabel({
      itemsPerPage,
      totalItems
    }),
    size: "sm",
    onChange: handleSelectChange,
    value: itemsPerPage
  }, itemsPerPageOptions.map(option => jsx("option", {
    key: option,
    value: option
  }, option))), jsx(Text, {
    variant: "contrast",
    sx: {
      whiteSpace: "nowrap"
    }
  }, setAfterLabel(totalItems)));
});

export { PaginationPerPageSelect };
